if (!Object.groupBy) {
  Object.groupBy = (items, callbackFn) => {
    // Object.create(null) avoids prototype-key collisions (e.g. an
    // input mapping to 'toString' won't surface the inherited
    // function); mirrors native Object.groupBy.
    const result = Object.create(null)

    for (const item of items) {
      const key = callbackFn(item)
      result[key] ||= []
      result[key].push(item)
    }
    return result
  }
}
